/**
 * 3D Foundation Project
 * Copyright 2025 Smithsonian Institution
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ShaderMaterial} from "three";

////////////////////////////////////////////////////////////////////////////////

/**
 * Renders the zone colors
 * Based on ff-three position shader : Copyright 2020 Ralph Wiedemeier, Frame Factory GmbH
 */
export default class ZoneShader extends ShaderMaterial
{
    isZoneShader = true;

    uniforms = {
        zoneMap: { value: null }
    };

    vertexShader = [
        "varying vec2 vUv;",

        "void main() {",
        "  #include <beginnormal_vertex>",
        "  #include <begin_vertex>",
        "  #include <project_vertex>",
        "  vUv = uv;",
        "}",
    ].join("\n");

    fragmentShader = [
        "varying vec2 vUv;",
        "uniform sampler2D zoneMap;",

        "void main() {",
        "  gl_FragColor = vec4(texture2D(zoneMap, vUv).xyz, 1.0);",
        "}"
    ].join("\n");
}